import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  allowedRole: 'stand' | 'festival' | 'promoter';
  redirectTo: string;
}

export function ProtectedRoute({ allowedRole, redirectTo }: ProtectedRouteProps) {
  const { user, userRole, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen bg-[#0d0e12] flex items-center justify-center text-white">Chargement...</div>;
  }

  // Si non connecté, rediriger vers l'accueil public
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Si l'email n'est pas vérifié, rediriger vers la page de vérification
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Si le rôle ne correspond pas au rôle autorisé, rediriger
  if (userRole && userRole !== allowedRole) {
     return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
